
// token 的key值
export const TOKEN_KEY = 'YiBao_User_Login_Token'
export const TOKEN_KEY_OLD = 'YiBao_User_Login_Token_Old'
export const OPERATOR_INFO_KEY = 'YiBao_Operator_Info'
// 免登录路由白名单
export const WHITE_LIST = [
  'login',
  '404'
]

// export const APP_ID = 'wwefeab37e94307253'

// export const AGENT_ID = 1000003

export const JS_API_LIST = [
  'selectEnterpriseContact',
  'openUserProfile',
  'selectExternalContact',
  'getCurExternalContact',
  'getCurExternalChat',
  'sendChatMessage',
  'getContext',
  'openEnterpriseChat',
  'onMenuShareAppMessage',
  'onMenuShareWechat',
  'onMenuShareTimeline',
  'shareAppMessage',
  'shareWechatMessage',
  'shareToExternalContact',
  'shareToExternalChat',
  'onHistoryBack',
  'hideOptionMenu',
  'showOptionMenu',
  'hideMenuItems',
  'showMenuItems',
  'hideAllNonBaseMenuItem',
  'showAllNonBaseMenuItem',
  'closeWindow',
  'openDefaultBrowser',
  'onUserCaptureScreen',
  'scanQRCode',
  'chooseInvoice',
  'enterpriseVerify',
  'chooseImage',
  'previewImage',
  'uploadImage',
  'downloadImage',
  'getLocalImgData',
  'startRecord',
  'stopRecord',
  'onVoiceRecordEnd',
  'playVoice',
  'pauseVoice',
  'stopVoice',
  'onVoicePlayEnd',
  'uploadVoice',
  'downloadVoice',
  'translateVoice',
  'previewFile',
  'startWifi',
  'stopWifi',
  'connectWifi',
  'getWifiList',
  'onGetWifiList',
  'onWifiConnected',
  'getConnectedWifi',
  'openBluetoothAdapter',
  'closeBluetoothAdapter',
  'getBluetoothAdapterState',
  'onBluetoothAdapterStateChange',
  'startBluetoothDevicesDiscovery',
  'stopBluetoothDevicesDiscovery',
  'getBluetoothDevices',
  'onBluetoothDeviceFound',
  'getConnectedBluetoothDevices',
  'createBLEConnection',
  'closeBLEConnection',
  'onBLEConnectionStateChange',
  'getBLEDeviceServices',
  'getBLEDeviceCharacteristics',
  'readBLECharacteristicValue',
  'writeBLECharacteristicValue',
  'notifyBLECharacteristicValueChange',
  'onBLECharacteristicValueChange',
  'startBeaconDiscovery',
  'stopBeaconDiscovery',
  'getBeacons',
  'onBeaconUpdate',
  'onBeaconServiceChange',
  'setClipboardData',
  'getNetworkType',
  'onNetworkStatusChange',
  'openLocation',
  'getLocation',
  'startAutoLBS',
  'stopAutoLBS',
  'onLocationChange',
  'hideChatAttachmentMenu',
  'selectCorpGroupContact'
]

// 公众号前缀
export const WEI_XIN_PATH = {
  other: '/',
  'rxa-other': '/h5-breastcancer/',
  page: '/h5-article-platform/custom-page/detail/',
  article: '/h5-article/detail/',
  form: '/h5-17healthy/custom-form/pre/',
  formPreview: '/h5-article-platform/custom-form/detail/'
}

export const SUB_TYPE = Object.freeze({
  1: '特需门诊',
  2: '专家门诊',
  3: '普通门诊',
  4: '普通B超',
  5: '专家B超',
  6: '专家穿刺',
  7: '普通穿刺',
  8: '手术',
  9: '消融',
  10: '碘131',
  11: '硬化治疗',
  12: '国际门诊',
  13: '国际B超',
  14: '细针穿刺检查',
  15: '粗针穿刺检查'
})

export const WEEK_MAP = Object.freeze({
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  7: '周日'
})

export const DAY_MAP = Object.freeze({
  4: '早上',
  1: '上午',
  2: '下午',
  3: '晚上'
})
